import { toast } from '@/components/toast';
import { RequestStatus } from '@/pages/avatar/common/types';
import { uploadFile } from '@/services/api';
import { logger } from '@/services/logger';
import createThumbnail, { ThumbnailResponseType } from '@/utils/thumbnail';
import axios from 'axios';
import { runInAction } from 'mobx';
import createAvatarStore from '../CreateAvatarStore';

const handleThumbnail = async (file: File) => {
    try {
        const thumbnail = (await createThumbnail(file, ThumbnailResponseType.Blob)) as Blob;
        createAvatarStore.setThumbnailSrc(URL.createObjectURL(thumbnail));
        const thumbnailFile = new File([thumbnail], 'thumbnail.png', { type: 'image/jpeg' });
        const thumbnailUrl = await uploadFile(thumbnailFile as File, undefined, { s3Uri: false });
        createAvatarStore.setThumbnailUrl(thumbnailUrl);
    } catch (error) {
        logger.error('failed to create thumbnail', error);
    }
};
const uploadFootage = async (file: File, abortSignal: AbortSignal) => {
    try {
        createAvatarStore.setFootageUploadStatus(RequestStatus.LOADING);
        const footageUrl = await uploadFile(file, abortSignal, { s3Uri: true });
        runInAction(() => {
            createAvatarStore.setFootageUrl(footageUrl);
            createAvatarStore.setFootageUploadStatus(RequestStatus.SUCCESS);
        });
    } catch (error) {
        if (axios.isCancel(error)) {
            return;
        }
        createAvatarStore.setFootageUploadStatus(RequestStatus.ERROR);
        logger.error('Failed to upload video', error);
        toast.error({
            title: 'Failed to upload video, please try again',
        });
    }
};

export const handleFootage = async (file: File | null, abortSignal: AbortSignal) => {
    if (!file) {
        logger.error('Trying to upload a footage video without a file');
        return;
    }

    await Promise.all([handleThumbnail(file), uploadFootage(file, abortSignal)]);
};
